import { jsxs as i, jsx as s } from "react/jsx-runtime";
import { clsx as u } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as se, useState as A, useEffect as I } from "react";
import { Breakpoints as ne } from "../../style/base/index.js";
import { getDownloadLinkInfo as ae } from "../../utils/get-download-link-info.js";
import { useIsDocumentRTL as oe } from "../../utils/use-rtl-direction.js";
import { useTableFilter as le } from "../../utils/use-table-filter.js";
import { useTableSort as ie } from "../../utils/use-table-sort.js";
import { RocheUIButton as ce } from "../button/roche-button.js";
import { RocheUIIcon as G } from "../icon/roche-icon.js";
import { RocheUIInput as de } from "../input/roche-input.js";
import e from "./roche-responsive-table.module.scss.js";
import { RocheUIMultipleAlternatives as V, SortIcon as S, SortOrder as B } from "./roche-responsive-table.types.js";
const me = 160, E = (a) => typeof a == "string" ? /* @__PURE__ */ s(
  "span",
  {
    className: e["responsive-table__cell-html"],
    dangerouslySetInnerHTML: { __html: a }
  }
) : a, ke = ({
  table: a,
  stickyHeader: k,
  sortable: v,
  filterable: O,
  noResults: P,
  alignText: h,
  multipleAlternatives: b,
  alternatedRow: N,
  alternatedColumn: g,
  caption: D,
  filterInputPlaceholder: F,
  clearFilterText: W,
  onResponsiveTableEvent: m
}) => {
  const j = oe(), _ = se(null), [$, R] = A(!1), [l, x] = A(""), { filteredData: z } = le(a.tbody, l), { sortedData: p, sortByIndex: c, sortDirection: f, toggleSort: H } = ie(z), w = p.length, y = N && Number(N) > 0 && !b ? Number(N) : void 0, M = g && Number(g) > 0 && !b && !y ? Number(g) : void 0;
  I(() => {
    if (!_.current) return;
    const t = new ResizeObserver(() => {
      var d;
      const r = _.current;
      if (!r) return;
      const { width: n } = r.getBoundingClientRect(), o = a.thead.length || (((d = a.tbody[0]) == null ? void 0 : d.body.length) ?? 0);
      if (n > ne.LARGE) {
        R(!1);
        return;
      }
      const C = n / o;
      R(C < me);
    });
    return t.observe(_.current), () => t.disconnect();
  }, [a]), I(() => {
    l !== "" && m({
      type: "update_filter",
      trackingValue: "filter",
      value: l,
      additionalParameters: {
        filteredResults: p.length
      }
    });
  }, [l]), I(() => {
    c !== null && m({
      type: "update_sort_by",
      trackingValue: "sort",
      value: f,
      additionalParameters: {
        sortedColumnNr: c,
        sortedColumn: a.thead.length ? a.thead[c].value : ""
      }
    });
  }, [c, f]);
  const q = (t) => c !== t ? S.DESCENDING : f === B.ASCENDING ? S.ASCENDING : S.DESCENDING, J = (t) => c !== t ? "none" : f === B.ASCENDING ? "ascending" : "descending", K = u(
    e["responsive-table__table"],
    k && e["responsive-table--sticky-header"],
    v && e["responsive-table--sortable"],
    h === "right" && e[`responsive-table--align-text-${h}`],
    b === V.ROWS && e["responsive-table--alternated-rows"],
    b === V.COLUMNS && e["responsive-table--alternated-columns"]
  ), Q = (t) => y === t + 1 ? e["responsive-table--alternated-row-single"] : "", X = (t) => M === t + 1 ? e["responsive-table--alternated-column-single"] : "", Y = (t) => {
    x(t);
  }, Z = () => {
    x(""), m({
      type: "clear_filter",
      trackingValue: "clear_filter"
    });
  }, U = (t) => {
    var T;
    const n = t.target.closest("a");
    if (!n) return;
    const o = n.getAttribute("href"), C = (T = n.textContent) == null ? void 0 : T.trim(), d = ae(o || "");
    if (d.isDownload) {
      m({
        type: "download",
        event: "download",
        value: o || "",
        additionalParameters: {
          file_type: d.extension,
          file_name: d.fileName
        }
      });
      return;
    }
    m({
      type: "link_click",
      event: "link_click",
      additionalParameters: {
        click_text: C || "",
        click_url: o || ""
      }
    });
  }, ee = () => /* @__PURE__ */ i("div", { className: e["responsive-table__filter"], children: [
    /* @__PURE__ */ s(
      de,
      {
        id: "responsive-table-filter",
        value: l,
        placeholder: F,
        onChange: Y,
        valid: !0,
        dirty: l !== "",
        hintParsed: "",
        onBlur: () => {
        }
      }
    ),
    /* @__PURE__ */ s(
      ce,
      {
        disabled: l === "",
        leftIcon: l === "" ? "search" : "loading",
        text: W ?? "",
        hasMarginTop: !1,
        onClick: Z
      }
    )
  ] }), L = (t) => /* @__PURE__ */ s("tr", { children: /* @__PURE__ */ s("td", { colSpan: t, children: /* @__PURE__ */ i("div", { className: u(e["responsive-table__no-results"]), children: [
    /* @__PURE__ */ s("span", { className: e["responsive-table__no-results-icon"], children: /* @__PURE__ */ s(G, { icon: "mobile", height: "24px" }) }),
    P
  ] }) }) }), te = () => /* @__PURE__ */ i("table", { className: K, onClick: U, children: [
    /* @__PURE__ */ s("caption", { className: e["responsive-table__caption"], children: D }),
    /* @__PURE__ */ s("thead", { className: e["responsive-table__header"], children: /* @__PURE__ */ s("tr", { className: e["responsive-table__header-row"], children: a.thead.map((t, r) => /* @__PURE__ */ s(
      "th",
      {
        className: e["responsive-table__header-item"],
        scope: "col",
        "aria-sort": v ? J(r) : void 0,
        children: v ? /* @__PURE__ */ i(
          "button",
          {
            type: "button",
            className: e["responsive-table__header-item--sortable"],
            onClick: () => H(r),
            children: [
              t.value,
              /* @__PURE__ */ s("span", { className: e["responsive-table__sort-icon"], children: /* @__PURE__ */ s(G, { icon: q(r), width: j ? "16px" : "12px", decorative: !1 }) })
            ]
          }
        ) : t.value
      },
      t.id
    )) }) }),
    /* @__PURE__ */ s("tbody", { children: w > 0 ? p.map((t, r) => /* @__PURE__ */ s(
      "tr",
      {
        className: u(
          e["responsive-table__body-row"],
          y && Q(r)
        ),
        children: t.body.map((n, o) => /* @__PURE__ */ s(
          "td",
          {
            className: u(
              e["responsive-table__body-item"],
              M && X(o)
            ),
            children: E(n.value)
          },
          n.id
        ))
      },
      t.id
    )) : L(a.thead.length) })
  ] }), re = () => {
    const t = a.thead.length ? a.thead.map((r, n) => ({
      id: r.id,
      header: r,
      body: p.map((o) => o.body[n])
    })) : p.map((r) => ({
      id: r.id,
      header: { id: "", value: "" },
      body: r.body.map((n) => n)
    }));
    return /* @__PURE__ */ i(
      "table",
      {
        className: u(
          e["responsive-table__table"],
          e["responsive-table__table--is-small"],
          k && e["responsive-table--sticky-header"],
          h === "right" && e[`responsive-table--align-text-${h}`]
        ),
        onClick: U,
        children: [
          /* @__PURE__ */ s("caption", { className: e["responsive-table__caption"], children: D }),
          /* @__PURE__ */ s("tbody", { children: w > 0 ? t.map((r) => /* @__PURE__ */ i("tr", { className: e["responsive-table__body-row"], children: [
            r.header.value && /* @__PURE__ */ s("th", { className: e["responsive-table__header"], scope: "row", children: r.header.value }),
            r.body.map((n) => /* @__PURE__ */ s("td", { className: e["responsive-table__body-item"], children: E(n.value) }, n.id))
          ] }, r.id)) : L() })
        ]
      }
    );
  };
  return /* @__PURE__ */ i("section", { ref: _, className: e["responsive-table"], children: [
    O && ee(),
    $ ? re() : te()
  ] });
};
export {
  ke as RocheUIResponsiveTable
};
